<app-side-menu>
  <div class="cashflow-view-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button
              type="button"
              class="btn btn-outline-light btn-back me-3"
              (click)="goBack()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div class="flex-grow-1">
              <h1 class="page-title">
                <i class="fas fa-wallet me-3"></i>
                Visualizar Lançamento de Fluxo de Caixa
              </h1>
              <p class="page-subtitle">Detalhes do lançamento</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p class="mt-3">Carregando lançamento...</p>
    </div>

    <!-- Erro -->
    <div *ngIf="error && !loading" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button type="button" class="btn btn-outline-danger btn-sm" (click)="loadEntry()">
          <i class="fas fa-redo me-1"></i>
          Tentar novamente
        </button>
      </div>
    </div>

    <!-- Conteúdo -->
    <div *ngIf="entry && !loading" class="row g-4">
      <!-- Card principal: Tipo e Valor -->
      <div class="col-12">
        <div class="card card-summary">
          <div class="card-body summary-body">
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div class="d-flex align-items-center gap-3">
                <span class="type-badge" [ngClass]="getTypeBadgeClass()">
                  <i class="fas" [ngClass]="(entry?.type || '').toString().toLowerCase() === 'entrada' ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                  {{ getTypeLabel() }}
                </span>
                <span class="entry-date">
                  <i class="fas fa-calendar-alt me-2"></i>
                  {{ formatDate(entry.date) }}
                </span>
              </div>
              <div class="amount-display" [ngClass]="getTypeBadgeClass()">
                {{ formatCurrency(entry.amount) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dados do lançamento -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-file-invoice me-2"></i>
              Dados do lançamento
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Data</label>
                  <div class="info-value">{{ formatDate(entry.date) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Tipo</label>
                  <div class="info-value">
                    <span class="type-badge-sm" [ngClass]="getTypeBadgeClass()">{{ getTypeLabel() }}</span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Descrição</label>
                  <div class="info-value description">{{ entry.description || '—' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Centro de Custo</label>
                  <div class="info-value">{{ entry.costCenterName || '—' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Valor</label>
                  <div class="info-value amount" [ngClass]="getTypeBadgeClass()">{{ formatCurrency(entry.amount) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Identificação -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-fingerprint me-2"></i>
              Identificação
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">ID do lançamento</label>
                  <div class="info-value id-value">#{{ entry.id }}</div>
                </div>
              </div>
              <div class="col-12" *ngIf="entry.createdAt">
                <div class="info-item">
                  <label class="form-label">Registrado em</label>
                  <div class="info-value">{{ formatDate(entry.createdAt) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ações -->
      <div class="col-12">
        <div class="card">
          <div class="card-body d-flex gap-2 flex-wrap">
            <button type="button" class="btn btn-primary" (click)="goToEdit()">
              <i class="fas fa-edit me-2"></i>
              Editar lançamento
            </button>
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
              <i class="fas fa-list me-2"></i>
              Voltar à lista
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
